var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCursorDiagonalDownUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_25_184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.2936 15.7073C26.9239 16.3362 28 15.8898 28 14.9994V4H17.0006C16.1102 4 15.6638 5.07608 16.2927 5.70636L19.29 8.71L8.71 19.29L5.70635 16.2927C5.07608 15.6638 4 16.1102 4 17.0006V28H14.9994C15.8898 28 16.3362 26.9239 15.7073 26.2936L12.71 23.29L23.29 12.71L26.2936 15.7073Z",
    fill: "#12131A"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.7115 22.1169L22.1169 8.7115L19.4112 6H26V12.5888L23.2885 9.88307L9.88308 23.2885L12.5888 26H6V19.4112L8.7115 22.1169ZM8.71 19.29L19.29 8.71L16.2927 5.70636C15.6638 5.07608 16.1102 4 17.0006 4H28V14.9994C28 15.8898 26.9239 16.3362 26.2936 15.7073L23.2901 12.7101L12.71 23.29L15.7073 26.2936C16.3362 26.9239 15.8898 28 14.9994 28H4V17.0006C4 16.1102 5.07608 15.6638 5.70635 16.2927L8.71 19.29Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_25_184",
    x: 1,
    y: 2.5,
    width: 30,
    height: 30,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.0745098 0 0 0 0 0.101961 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_25_184"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_25_184",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursorDiagonalDownUp);
export default __webpack_public_path__ + "static/media/cursor-diagonal-down-up.e43b3272b8c34b25bfb789c4db6cca89.svg";
export { ForwardRef as ReactComponent };